export const launchCustomEvent = (eventName) => {
  const event = new Event(eventName);
  document.dispatchEvent(event);
};


// WEBPACK FOOTER //
// ./src/_override/common/customEvent.js